import { render, staticRenderFns } from "./SaveButtons.vue?vue&type=template&id=5bef5992&"
import script from "./SaveButtons.vue?vue&type=script&lang=js&"
export * from "./SaveButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports